import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { OnsiteLocation } from '../../../stores/types/video';
import { GreenroomState as GS } from '../../../stores/types/types';
import FeedOnsiteLocation from './feed-onsite-location';
import Title from '../title';
import useShotMemos from '../../../hooks/use-shot-memos';

interface Props {
	feedPosition: number;
	mediaId: number;
}

function FeedOnsiteLocationSpotlight(props: Props) {
	const { feedPosition, mediaId } = props;
	const onsiteLocations = useSelector((s: GS) => s.VideoReducer.onsiteLocations);
	const onsiteLocationStreams = useSelector((s: GS) => s.VideoReducer.onsiteLocationStreams);

	const { currentShot } = useShotMemos();
	const { shot_id: shotId } = currentShot;

	const onsiteLocation = useMemo(
		() => onsiteLocations.find((ls: OnsiteLocation) => ls.id === mediaId),
		[onsiteLocations, mediaId],
	);

	const locationStreams = useMemo(
		() => onsiteLocationStreams.get(mediaId),
		[onsiteLocationStreams, mediaId],
	);

	return (
		<>
			<FeedOnsiteLocation
				feedPosition={feedPosition}
				onsiteLocation={{
					data: onsiteLocation,
					stream: locationStreams?.[0],
				}}
				isSpotlightFeed={true}
				dropCallback={() => {}}
			/>
			<Title
				key={shotId}
				onsiteLocation={onsiteLocation}
			/>
		</>
	);
}

export default memo(FeedOnsiteLocationSpotlight);
